import api from '../api/axios';

export const tareasService = {
  getTareas: async () => {
    const { data } = await api.get('/tasks');
    return data;
  },

  crearTarea: async (datos) => {
    const { data } = await api.post('/tasks', datos);
    return data;
  },

  actualizarTarea: async ({ id, datos }) => {
    const { data } = await api.put(`/tasks/${id}`, datos);
    return data;
  },

  eliminarTarea: async (id) => {
    const { data } = await api.delete(`/tasks/${id}`);
    return data;
  },
};
